import React from "react";

import { defineMessage, IntlShape } from "react-intl";

import Resource from "@mapmycustomers/shared/types/entity/Resource";
import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";
import { nameComparator, userDisplayNameComparator } from "@mapmycustomers/shared/util/comparator";

import { userDisplayName } from "@app/util/formatters";

import styles from "../Resources.module.scss";

const entireOrgMesage = defineMessage({
  id: "resources.list.sharedWith.entireOrg",
  defaultMessage: "Entire Organization",
  description: "Entire organization message",
});

const getSharedWithLabel = (intl: IntlShape, resource: Resource, users: User[], teams: Team[]) => {
  const { user, userIds } = resource;
  if (userIds.length === users.length) {
    return [
      <span className={styles.sharedWithItem} key={"entireOrg"}>
        {intl.formatMessage(entireOrgMesage)}
      </span>,
    ];
  }

  const selectedTeams = teams.filter(
    (team) => team.users.length && team.users.every(({ id }) => userIds.includes(id))
  );
  const selectedTeamIds = selectedTeams.map(({ id }) => id);
  const remainingUsers = users.filter(
    ({ id, teams }) =>
      user.id !== id &&
      userIds.includes(id) &&
      !teams.some(({ id }) => selectedTeamIds.includes(id))
  );

  return [
    ...selectedTeams.sort(nameComparator).map(({ id, name }, index) => (
      <span className={styles.sharedWithItem} key={id}>
        {index !== 0 && ", "}
        {name}
      </span>
    )),
    ...remainingUsers.sort(userDisplayNameComparator).map((user, index) => (
      <span className={styles.sharedWithItem} key={user.id}>
        {(index !== 0 || selectedTeams.length > 0) && ", "}
        {userDisplayName(user)}
      </span>
    )),
  ];
};

export default getSharedWithLabel;
